export default __webpack_public_path__ + "static/media/giftSuccessfull-mobile.923991b2.webp";